<template>
	<div>
		<v-snackbar
			v-model="innerShow"
			:color="color"
		>
			{{ text }}
		</v-snackbar>
	</div>
</template>

<script>
  export default {
    name: "MessageComponent",
    props: {
      show: Boolean,
      text: String,
      color: String,
      cleanMessage: Function,
    },
    computed: {
      innerShow: {
        get: function () {
          return this.show
        },
        set: function () {
          this.cleanMessage()
        }
      }
    }
  }
</script>

<style scoped>

</style>
